module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"extra_field_filter":"Extra Field Filter","filter_by":"filter by"},"id":{"extra_field_filter":"Filter info tambahan","filter_by":"filter by"}}')
  delete Component.options._Ctor
}
